export interface NoteRecord {
  id: string;
  /** 노트를 분류할 학생 이름 (선생님이 직접 입력) */
  studentName: string;
  examName: string;
  examType: string;
  subject: string;
  problemNumber: string;
  section: string;
  problemText: string;
  /** PDF 원본에서 캡쳐된 문제 이미지(Data URL) */
  problemImage?: string;
  chapter: string;
  problemType: string;
  wrongReason: string;
  keyPoint: string;
  retrySolution: string;
  createdAt: string;
}

export function createEmptyNote(): NoteRecord {
  return {
    id: '',
    studentName: '',
    examName: '',
    examType: '수능',
    subject: '수학',
    problemNumber: '',
    section: '',
    problemText: '',
    problemImage: undefined,
    chapter: '',
    problemType: '',
    wrongReason: '',
    keyPoint: '',
    retrySolution: '',
    createdAt: '',
  };
}